export const DIFFERENCE_VALUES = {
  ACTIVE: 'Aktiv',
  COMPANY: 'Firma',
  ID: 'ID',
  NAME: 'Name',
  ORG_GROUPS: 'Organisations-Gruppen',
  SYNC_KEY: 'Externe ID',
} as const;
